<template>
    <ChipList
        v-bind="forwardedProps"
        :delimiter-regex="delimiterRegex"
        :validate="isEmail"
    />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    import { isEmail } from '@evidentid/universal-framework/validation';

    import Icon from '@/components/common/Icon.vue';
    import ChipList from '@/components/forms/ChipList.vue';

    // PRODUCT-26110 Task 12 (COMPONENT_V_MODEL): migrated to the Vue 3 v-model
    // contract. Consumed via v-model by fields/BulkEmail.vue, and manually
    // (:model-value/@update:model-value) by google/GlsEmailQuestion.vue. This is a
    // pure forwarding wrapper to ChipList.vue.
    @Component({
        components: { ChipList, Icon },
    })
    export default class EmailList extends Vue {
        @Prop({ type: Array, default: () => [] })
        private modelValue!: string[];

        @Prop({ type: String, default: 'Add an email' })
        private placeholder!: string;

        @Prop({ type: Boolean, default: false })
        private disabled!: boolean;

        private isEmail = isEmail;
        private delimiterRegex = /[^a-zA-Z0-9@^.|?*+!{$#%&'\-\/=_`}~]+/g;

        // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): Vue's template compiler rejects
        // two bare `v-bind` directives on the same element ("Duplicate attribute"), so
        // `v-bind="$props"` and the former `v-on="$listeners"` (now `$attrs`, which
        // carries listeners as `onXxx` keys) must be merged into a single object.
        private get forwardedProps(): Record<string, unknown> {
            return { ...this.$props, ...this.$attrs };
        }
    }
</script>
